// src/components/UserSideLoader.jsx
import React from "react";
import Lottie from "lottie-react";
import animationData from "../assets/animations/CarInCity.json";

const SIZES = {
  md: { w: 160, h: 160, glow: "w-40 h-40", text: "text-sm" },
  lg: { w: 220, h: 220, glow: "w-56 h-56", text: "text-base" },
  xl: { w: 280, h: 280, glow: "w-72 h-72", text: "text-lg" },
};

export default function Loader({
  size = "lg",
  label = "Loading…",
  className = "",
}) {
  const cfg = SIZES[size] || SIZES.lg;

  return (
    <div
      className={`relative inline-flex flex-col items-center justify-center px-6 py-6 rounded-2xl  ${className}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      {/* soft glow behind animation */}
      <div className={`absolute -z-10 ${cfg.glow} rounded-full`} />

      {/* animation */}
      <Lottie
        animationData={animationData}
        loop
        style={{ width: cfg.w, height: cfg.h }}
      />

      {/* label under animation */}
      <span
        className={`${cfg.text} mt-3 font-semibold tracking-wide text-gray-700`}
      >
        {label}
      </span>
    </div>
  );
}
